<template>
    <v-dialog v-model="dialog" max-width="600" persistent>

        <v-card>
            <v-toolbar dark color="primary">
                <v-toolbar-title class="headline primary white--text"><v-icon color="white" class="pr-2">mdi-form-textbox-password</v-icon> Alterar Senha </v-toolbar-title>
            </v-toolbar>

            <v-form ref="form" v-model="validDialog" lazy-validation>

                <v-card-text class="mt-4">

                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <v-text-field :rules="fieldRules" v-model="senhaAntiga" :type="showPassword1 ? 'text' : 'password'" label="Senha Atual" prepend-icon="mdi-form-textbox-password" :append-icon="showPassword1 ? 'mdi-eye' : 'mdi-eye-off'" @click:append="showPassword1 = !showPassword1" :counter="50" maxlength="50" dense outlined/>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                            <v-text-field :rules="fieldRules" v-model="senhaNova" :type="showPassword2 ? 'text' : 'password'" label="Senha Nova" prepend-icon="mdi-form-textbox-password" :append-icon="showPassword2 ? 'mdi-eye' : 'mdi-eye-off'" @click:append="showPassword2 = !showPassword2" :counter="50" maxlength="50" dense outlined/>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                            <v-text-field :rules="[(senhaNova === repetirSenha) || 'As senhas devem ser iguais!']" v-model="repetirSenha" :type="showPassword3 ? 'text' : 'password'" label="Repetir Senha" prepend-icon="mdi-form-textbox-password" :append-icon="showPassword3 ? 'mdi-eye' : 'mdi-eye-off'" @click:append="showPassword3 = !showPassword3" :counter="50" maxlength="50" dense outlined/>
                        </v-col>
                    </v-row>

                </v-card-text>

                <v-card-actions class="teste">
                    <v-spacer/>
                    <v-btn color="secundary" text @click="dialog = false">Fechar</v-btn>
                    <v-btn color="primary" @click="Salvar()" text :disabled="!validDialog" >Salvar</v-btn>
                </v-card-actions>

            </v-form>

        </v-card>

    </v-dialog>
</template>

<script>
import UsuarioService from '../../core/services/geral/UsuarioService'

export default {
    props:{
        value: {
            required: true
        }
    },
    data: () => ({
        validDialog: false,
        dialog: false,
        senhaAntiga: '',
        senhaNova: '',
        repetirSenha: '',
        showPassword1: false,
        showPassword2: false,
        showPassword3: false,
        service: new UsuarioService(),
        sessionApp: {},
        fieldRules: [ v => !!v || 'Campo obrigatório' ],
    }),
    watch: {
        value: function(){
            this.dialog = this.value;
        },
        dialog: function(){
            if(!this.dialog){
                this.$emit('fechou');
            }
        }
    },
    mounted() {
        this.sessionApp = JSON.parse(localStorage.sessionApp); 
    },
    beforeUpdate(){
        if(!this.dialog){
            this.senhaNova = '',
            this.senhaAntiga = '',
            this.repetirSenha = ''
            this.$emit('fechou');
        }
    },
    methods:{
        Salvar(){
            this.service.AlterarSenha(this.sessionApp.usuarioId, this.senhaAntiga, this.senhaNova)
            .then(
                res=>{
                    this.Close();
                    this.$swal("Aviso", res.data, res.status == 200 ? "success" : "warning");
                },
                err => this.$swal('Aviso', err.response.data, err.response.status === 400 ? 'warning' : 'error')
            )
        },
        Close(){
            this.dialog = false;   
        }
    }
}

</script>